import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "tooltipMessage", "tooltipOnHide", "hideTooltipOnMouseDown", "hideTooltip"];
import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import ActionButton from './action-button';
var ActionStackItem = function ActionStackItem(_ref) {
  var content = _ref.content,
    tooltipMessage = _ref.tooltipMessage,
    tooltipOnHide = _ref.tooltipOnHide,
    hideTooltipOnMouseDown = _ref.hideTooltipOnMouseDown,
    hideTooltip = _ref.hideTooltip,
    props = _objectWithoutProperties(_ref, _excluded);
  return hideTooltip ? /*#__PURE__*/React.createElement(ActionButton, _extends({}, props, {
    content: content
  })) : /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipMessage || content,
    onHide: tooltipOnHide,
    hideTooltipOnMouseDown: hideTooltipOnMouseDown
  }, function (tooltipProps) {
    return /*#__PURE__*/React.createElement(ActionButton, _extends({}, props, {
      content: content,
      tooltipProps: tooltipProps
    }));
  });
};
export default ActionStackItem;